<template>
  <v-card
    color="grey lighten-4"
    light
  >
    <v-card-text>
      <content-section
        id="timeline"
        :title="detailed ? 'My Life in a Nutshell' : 'My Experiences'"
      >
        <template slot="actions">
          <div>
            <v-switch
              v-model="detailed"
              :label="detailed ? 'Detailed' : 'Summary'"
            />
          </div>
        </template>

        <v-timeline
          dense
        >
          <v-timeline-item
            v-for="(item, i) in orderedItems"
            :key="i"
            :icon="item.icon || ''"
            :class="{transparent: item.transparent}"
            large
          >
            <template
              v-if="item.iconImage"
              v-slot:icon
            >
              <v-avatar>
                <img
                  :src="publicPath(item.iconImage)"
                >
              </v-avatar>
            </template>
            <template v-slot:opposite />
            <v-layout>
              <v-flex
                v-if="$vuetify.breakpoint.smAndUp"
                md1
                sm2
                align-self-center
              >
                <span>{{ item.year }}</span>
              </v-flex>
              <v-flex
                md11
                sm10
                xs12
              >
                <v-card class="elevation-1">
                  <v-card-title class="pb-0">
                    <div>
                      <p v-if="$vuetify.breakpoint.xsOnly">
                        {{ item.year }}
                      </p>
                      <h3>{{ item.title }}</h3>
                    </div>
                  </v-card-title>
                  <v-card-text>
                    <v-layout wrap>
                      <v-flex
                        :md7="!!item.image"
                        :md12="!item.image"
                        xs12
                      >
                        <div class="mr-1">
                          <span
                            v-if="item.text"
                            class="pre"
                          >{{ item.text }}</span>
                          <!-- eslint-disable vue/no-v-html -->
                          <div
                            v-else-if="item.html"
                            v-html="item.html"
                          />
                          <!-- eslint-enable vue/no-v-html -->
                        </div>
                      </v-flex>
                      <v-flex
                        v-if="item.image"
                        md5
                        xs12
                      >
                        <div
                          class="mt-2"
                        >
                          <v-carousel
                            v-if="Array.isArray(item.image)"
                            :show-arrows="false"
                            :height="325"
                          >
                            <v-carousel-item
                              v-for="(citem,ci) in item.image"
                              :key="ci"
                              :src="publicPath(citem)"
                            />
                          </v-carousel>
                          <v-img
                            v-else
                            :max-height="item.imageHeight ? item.imageHeight : ''"
                            :src="publicPath(item.image)"
                          />
                        </div>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
          </v-timeline-item>
        </v-timeline>
      </content-section>
    </v-card-text>
  </v-card>
</template>

<script>
import ContentSection from '@/views/dark-template/content/Section'
export default {
  name      : 'Timeline',
  components: { ContentSection },
  data      : () => ({
    detailed: false,
    items   : [
      {
        detailed   : true,
        transparent: true,
        year       : '1993',
        title      : 'Born on July 16, 1993',
        html       : 'With a chance of %0.00000000000512.<br>I\'m completely aware of value of the life!',
        icon       : 'mdi-cake-variant',
      },
      {
        year : '2016',
        title: 'TCS - Bayer Pharmaceuticals',
        html : `
         <ul>
            <li>Standalone development of e-tendering application with sub-modules such as Master Data Setup (Screen based and excel upload based), Template Configuration, Tender publish and award etc.</li>
            <li>Implemented Active-MQ to notify the vendor (via mail and system based case transfer).</li>
            <li>Multi-lingual support for various geographies.</li>
            <li>Rest API calls for vendor portal, implemented swagger-ui, JWT token authorization.</li>
         </ul>
        `,
        image: 'img/timeline/Bayer.png',
        iconImage : 'img/timeline/tcs.png',
      },
      {
        year : '2017/18',
        title: 'TCS - Weatherford Drilling Production services',
        html : `
          <ul>
             <li> Developed and integrated the various sub-modules in multi-phase challenging development cycles broadly based on Core Java and ZK Framework.</li>
             <li> Implemented automated test case execution and saved a lot of team efforts. </li>
             <li> Received Accolades from team and client. </li>
          </ul>
          <p>
            
          </p>
        `,
        image: 'img/timeline/weatherford.png',
        iconImage : 'img/timeline/tcs.png',
      },
      {
        year : '2019',
        title: 'TCS - Wincanton Logistics Company',
        html : `
           <ul>
             <li> Got the opportunity to lead a team with freshers of size 7, was given the responsibility to complete admin modules with new screens and approach for ease of user to configure the data by self. </li>
             <li>  Designed, planned and executed the screen designs, DB designs and delivered the screen timely which helped the end-user to work effectively. </li>
          </ul>
        `,
        image: 'img/timeline/wincanton.png',
        iconImage : 'img/timeline/tcs.png',
      },
      // {
      //   year : '2020',
      //   title: 'Work in progress',
      //   html : `
      //     <p>
      //         Work in Progress
      //     </p>
      //     <p>
      //       Work in Progress
      //     </p>
      //   `,
      //   image: '',
      //   icon : 'mdi-github-circle',
      // },
      {
        year : '2020',
        title: 'Created and open sourced this portfolio',
        html : `
          <p>
              Current status: <span class="light-blue--text lighten-3">Open Sourced</span><br>Available on: <a target="_blank" href="https://github.com/sashin-a/vue-modern-portfolio">sashin-a/vue-modern-portfolio</a>
          </p>
          <p>
            A Vue.js-based and powered-by-Vuetify (material UI kit) integrated with Google Firebase to deploy and monitor!
          </p>
        `,
        image: 'img/timeline/my-portfolio.jpg',
        icon : 'mdi-github-circle',
      },
      {
        year : '2020',
        title: 'Cognizant - Full stack development',
        html : `
          <p>
              Completed Full Stack Engineer certification as per the client norms.
          </p>
          <p>
            Indugled in web development for mobile/desktop application of following types : 
            <ul>
                <li>Mobile application to create claims, estimate damages (Smart Estimate) based on ML integration, based on Vuejs powered with Quasar framework for native browsing experience</li>
                <li>Developed portal application for admin management to upload data within the system integrated with the salesforce through Apache Kafka.</li>
                <li>Implemented backend services based on microservices with Eureka Server(s), Discovery client, Netflix zuul server.</li>
            </ul>
          </p>
        `,
        image    : 'img/timeline/CCC.png',
        iconImage: 'img/timeline/cognizant.png',
      },
      // {
      //   year : 'So far ...',
      //   title: 'Written 340+ Unique Articles!',
      //   html : `I'm the guy who loves teaching! So far, I've written 340+ unique articles which most of them are computer-related. You can access them here:
      //               <ul><li><a target="_blank" href="https://bytegate.ir/author/amirrezanasiri/">My posts on Bytegate.ir</a> (260+ Computer-related)</li><li><a target="_blank" href="http://bobet.ir/author/amirrezanasiri/">My posts on Bobet.ir</a> (80+ translations)</li></ul>`,
      //   icon: 'mdi-fountain-pen-tip',
      // },
    ],
  }),
  computed: {
    orderedItems () {
      const items = [...this.items].reverse()
      if (this.detailed)
        return items
      return items.filter((item) => {
        return !item.detailed
      })
    },
  },
}
</script>

<style scoped>
.title {
  border-bottom: 2px #bfbfbf solid;
  line-height: 1.5 !important;
}
.pre {
  white-space: pre;
}
.transparent{
  opacity: 0.6;
}
</style>
